import {PROABONO_BACKOFFICE_URL} from './constants';

const computeProAbonoUrl = (contractNumber) => `${PROABONO_BACKOFFICE_URL}&referencecustomer=contract%3A%3A${contractNumber}`

export default computeProAbonoUrl